// import Swiper JS
import Swiper from 'swiper';
// import Swiper styles
import 'swiper/css';

export default () => {
  const cardList = document.querySelectorAll('[component="room-card-list"]');

  cardList.forEach((cardListItem) => {
    const roomItems = cardListItem.querySelectorAll('[child="room-card-item"]');

    roomItems.forEach((roomItem) => {
      const card = roomItem.querySelector('[component="card"]');
      const slider = roomItem.querySelector('[component="card-slider"]');

      const slot = card.querySelector('[child="image-slider-slot"]');

      if (slot && slider) {
        slot.appendChild(slider);

        const sliderAppended = card.querySelectorAll('[component="card-slider"]');

        sliderAppended.forEach((sliderComponent) => {
          const swiperElement = sliderComponent.querySelector('.swiper');
          const arrowLeft = sliderComponent.querySelector('[child="arrow-left"]');
          const arrowRight = sliderComponent.querySelector('[child="arrow-right"]');

          const swiper = new Swiper(swiperElement, {
            loop: true,
            slidesPerView: 1,
            nested: true,
          });

          arrowRight.addEventListener('click', () => {
            swiper.slideNext();
          });

          arrowLeft.addEventListener('click', () => {
            swiper.slidePrev();
          });
        });
      }
    });
  });
};
